import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import featureServiceIntervalStyles from './featureServiceIntervalStyles';
import { GetFeatureChildren_featureChildren } from '../../../../../../graphql/queries/__generated__/GetFeatureChildren';
import Price from '../../../../../../../gqlCommon/components/presentation/Price';
import clsx from 'clsx';
import { PriceDisplayType } from '../../../../../../../../../common/enum/PriceDisplayType';
import usePrice from '../../../../../../../gqlCommon/hooks/prices/usePrice';

export interface IServiceIntervalProps {
  serviceInterval: GetFeatureChildren_featureChildren;
}

const FeatureServiceInterval: FunctionComponent<IServiceIntervalProps> = ({ serviceInterval }) => {
  const styles = featureServiceIntervalStyles();
  const { primaryPrice } = usePrice(serviceInterval.prices);

  return (
    <Box data-test="customise:featureServicePlanInterval" key={serviceInterval.code} className={styles.itemContainer}>
      <Typography variant="caption" className={styles.itemLabel}>
        {serviceInterval.label}
      </Typography>
      <Price
        className={clsx(styles.itemValue)}
        price={primaryPrice?.money.amount}
        data-test={'customise:featureServicePlanInterval:price'}
        priceDisplayType={PriceDisplayType.PRIMARY_OPTIONS}
      />
    </Box>
  );
};

export default FeatureServiceInterval;
